import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession, refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const fragment = new URLSearchParams(location.hash.replace(/^#/, ''));
    const query = new URLSearchParams(location.search);
    const sessionId = fragment.get('session_id');
    const state = query.get('oauth_state');
    // Discard the one-use provider identifier immediately; never log or persist it.
    // React Router retains this callback until the final reactive navigate below.
    window.history.replaceState(window.history.state, '', location.pathname);

    const fail = async (code) => {
      if (query.get('google_intent') === 'link' && await refreshUser()) {
        navigate('/profile', { replace: true, state: { googleError: code } });
      } else {
        navigate('/login', { replace: true, state: { oauthError: code } });
      }
    };
    if (query.has('error') || fragment.has('error')) {
      fail('google_cancelled');
      return;
    }
    if (!sessionId || !state) {
      fail('google_state_invalid');
      return;
    }
    exchangeSession(sessionId, state).then(({ user, linked }) => {
      const destination = linked ? '/profile' : (user.onboarding_completed ? '/dashboard' : '/onboarding');
      navigate(destination, { replace: true });
    }).catch((error) => fail(error?.response?.data?.detail?.code || 'google_session_invalid'));
  }, [exchangeSession, refreshUser, navigate, location]);

  return <div className="min-h-screen bg-pp-bg" data-testid="google-auth-callback" aria-busy="true" />;
}